import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpEvent, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {AppConfig} from '../_helpers/appconfig.service';
import { Account } from '../_models/account.interface';
import { NotificationTemplate, NotificationTemplateUpdateResponse } from '../_models/notificationtemplate.interface';
import { Api } from '../_models/api.interface';
import { Webhook } from '../_models/webhook.interface';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Configuration, Debtor, UserList, UserRoleList } from '../_models';
import { CustomerReportExport } from "../_models/customerReportExport.interface";

@Injectable()
export class CustomerService {

  _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();
  httpOptions: any;
  public defaultHeaders = new HttpHeaders();
  public templateNotificationId: string | '' = '';
  public templateNotificationFormType: 'EDIT' | 'DUPLICATE' | '';

  constructor(private http: HttpClient) {
    let token = localStorage.getItem("id_token");
    this.httpOptions = {
      headers: new HttpHeaders({
        "Authorization": "Bearer " + token,
        'Content-Type': 'application/json'
      })
    };
  }

    getCustomerDebtorsForImport(public_id?:string, observe?: 'response'): Observable<any> {
        return this.http.get(`${this._kcmssvcURL}/customers/` + public_id + `/debtors?status=1`,  { observe: 'response'})
                .pipe(map(res => res)
                );
              }//end

    getCustomerDebtorsList(public_id?:string): Observable<any> {
           return this.http.get(`${this._kcmssvcURL}/customers/` + public_id + `/debtors`)
            .pipe(map(res => res)
            );
        }//end


    getCustomerList(public_id : string, status : number, type: number, limit:number, start:number, search:string): Observable<any> {
        if (public_id === null || public_id === undefined) {
            throw new Error('Required parameter customer public Id was null or undefined when calling to getCustomerList.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        if (status !== undefined && status !== null && status.toString() !== '') {
            queryParameters = queryParameters.set('status', <any>status);
        }

        if (type !== undefined && type !== null && type.toString() !== '') {
            queryParameters = queryParameters.set('type', <any>type);
        }

        if (start !== undefined && start !== null && start.toString() !== '') {
            queryParameters = queryParameters.set('start', <any>start);
        }

        if (limit !== undefined && limit !== null && limit !== 0 && limit.toString() !== '') {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        if (search !== undefined && search !== null && search !== '') {
            queryParameters = queryParameters.set('search', <any>search);
        }

        return this.http.get(`${this._kcmssvcURL}/customers/`+public_id+`/debtors`,
        {
            params: queryParameters,
            observe: 'response'
        }
    );
    }

     //Get Company Details
    public getCustomerCompanyDetailsList(publicId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        return this.http.get(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}`,
        {
            observe: 'response'

        }
        )
        .pipe(map(response => response));


    }//end




     /**
     * get_customer_account_list
     * Get Customer Account List
     * @param publicId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCustomerAccountList(publicId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        return this.http.get(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/accounts`)
        .pipe(map(response => response));



    }//end


    /**
     * get_customer_account_list Bank and PSP Accounts only
     * Get Customer Account List Bank and PSP Accounts only
     * @param publicId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
            public getCustomerBankPspAccountList(publicId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

            return this.http.get(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/accounts?type=(103)`)
            .pipe(map(response => response));



        }//end

    /**
     * get_customer_notification_template_list
     * Get Customer Notification Template List
     * @param publicId
     * @param limit
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCustomerNotificationTemplateList(publicId: string, limit: number = 100, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling getCustomerNotificationTemplateList.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', limit.toString());
        }

        return this.http.get<Array<NotificationTemplate>>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/notification_templates`,
            {
                params: queryParameters
            }
        );
    }

    /**
     * get Individual notification_template
     * Get Customer Notification Template List
     * @param publicId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getIndNotificationTemplateDetail(publicId: string): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter public Id was null or undefined when calling getCustomerNotificationTemplateList.');
        }

        return this.http.get<NotificationTemplate>(`${this._kcmssvcURL}/notification_templates/${encodeURIComponent(String(publicId))}`,
            {

            }
        );

    }//end





    /**
     * create_notification Template
     * Create a Notification Template
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */

    public createNotificationTemplate(publicId: string,body: NotificationTemplate, observe?: 'body', reportProgress?: boolean): Observable<NotificationTemplate>;
    public createNotificationTemplate(publicId: string,body: NotificationTemplate, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NotificationTemplate>>;
    public createNotificationTemplate(publicId: string,body: NotificationTemplate, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NotificationTemplate>>;
    public createNotificationTemplate(publicId: string,body: NotificationTemplate, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined)
        {
            throw new Error('Required parameter body was null or undefined when calling create Notification Template.');
        }


        return this.http.post<NotificationTemplate>(`${this._kcmssvcURL}/notification_templates`,
            body,
            {
              observe: 'response',
            }
        );
    }



    public updateNotificationTemplate(publicId: string, body: NotificationTemplate): Observable<NotificationTemplateUpdateResponse> {
        if (publicId === null || publicId === undefined) {
        throw new Error('Required parameter public Id was null or undefined when calling updateDebtor.');
        }
        const headers = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.patch<NotificationTemplateUpdateResponse>(`${this._kcmssvcURL}/notification_templates/${encodeURIComponent(String(publicId))}`, body, {headers: headers})
        }

    private handleError(error: any) {
        var applicationError = error.headers.get('Application-Error');
        var serverError = error.json();
        var modelStateErrors: string = '';
        if (!serverError.type) {
            console.log(serverError);
            for (var key in serverError) {
                if (serverError[key])
                    modelStateErrors += serverError[key] + '\n';
            }
        }
        modelStateErrors = modelStateErrors == '' ? null : modelStateErrors;

        return Observable.throw(applicationError || modelStateErrors || 'Server error');
    }//end

    private getHeaders() {
        let headers = new Headers();
        headers.append('Accept', 'application/json');
        return headers;
    }//end


    public async getCustomerAccountListPromise(publicId: string, observe: any = 'body', reportProgress: boolean = false ) {
        return await this.http.get(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/accounts`)
        .toPromise();
    }//end


      /**
     * get Individual Api Details
     * Get Individual Api Details
     * @param publicId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getApiDetails(publicId: string): Observable<Api> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter public Id was null or undefined when calling getApiDetails.');
        }

        return this.http.get<Api>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/api`,
            {

            }
        );

    }//end








    public  updateAPI(body: Api, publicId: string): Observable<Api> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateAPI.');
        }
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling updateAPI.');
        }

        let headers = this.defaultHeaders;

        return this.http.patch<Api>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/api`,

        body,
            {
                withCredentials: null,
                headers: headers
             }
        );
    } // End


     /**
     * get Individual Webhook Details
     * Get Individual Webhook Details
     * @param publicId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getWebhook(publicId: string): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter public Id was null or undefined when calling getWebhookDetails.');
        }

        return this.http.get<Webhook>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/webhook`,
            {

            }
        );

    }//end

   public createWebhook(publicId: string,body: Webhook, observe?: 'body'): Observable<Webhook>;
   public createWebhook(publicId: string,body: Webhook, observe?: 'response'): Observable<HttpResponse<Webhook>>;
   public createWebhook(publicId: string,body: Webhook, observe?: 'events'): Observable<HttpEvent<Webhook>>;
   public createWebhook(publicId: string,body: Webhook, observe: any = 'body', reportProgress: boolean = false ): Observable<any>
   {
        if (body === null || body === undefined) {
            throw new Error('Required parameter webhook was null or undefined when calling update Webhook.');
        }
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling update Webhook.');
        }
        const headers = new HttpHeaders().set('Content-Type', 'application/json');

        return  this.http.patch<Webhook>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/webhook`,

        body,
        {
            withCredentials: null,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
         }
        );
    } // End

   public testWebhook(publicId: string, body: Webhook): Observable<any> {
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling testWebhook.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter webhook was null or undefined when calling testWebhook.');
        }
        const headers = new HttpHeaders().set('Content-Type', 'application/json');

        return this.http.post<any>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/webhook/test`,
            body,
            { headers: headers }
        );
    } // End



    getCustomerUserList(public_id?:string): Observable<UserList[]> {
        return this.http.get<UserList[]>(`${this._kcmssvcURL}/customers/` + public_id + `/users`)
         .pipe(map(res => res)
         );
     }

    async getUserRoleList(public_id?:string){
        return this.http.get(`${this._kcmssvcURL}/customers/` + public_id + `/configurations/user.properties`).toPromise();
     }

     getUserRoleListObservable(public_id?:string): Observable<Configuration<UserRoleList>>{
        return this.http.get<Configuration<UserRoleList>>(`${this._kcmssvcURL}/customers/` + public_id + `/configurations/user.properties`);
     }

    checkPaymentCodeConfiguration(publicId:string){
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling payment code configuration.');
        }
        return this.http.get<any>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/payment_code.configuration`).toPromise();
    }

    checkPaymentCodeConfigurationObservable(publicId: string): Observable<Configuration>{
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling payment code configuration.');
        }
        return this.http.get<Configuration>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/payment_code.configuration`);
    }

    getCustomerListBySearch(publicId:string ,search: string) {
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        if (search !== undefined && search !== null && search !== '') {
            queryParameters = queryParameters.set('search', <any>search);
        }

        return this.http.get<any>(`${this._kcmssvcURL}/customers/`+publicId+`/debtors?search=`+search);
    }

    downloadTemplatefile(url: string) {
        const headers = new HttpHeaders().set("InterceptorSkipHeader", 'Yes');
        return this.http.get(url,
            {   headers:headers,
                responseType: 'blob',
                 observe: 'response'
            });
      }

      public reportExport(customerId: string, status: string, type: string, search: string): Observable<CustomerReportExport> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customer public ID was null or undefined when calling to reportExport.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        if (status !== undefined && status !== null && status.toString() !== '') {
            queryParameters = queryParameters.set('status', <string>status);
        }

        if (type !== undefined && type !== null && type.toString() !== '') {
            queryParameters = queryParameters.set('type', <string>type);
        }

        if (search !== undefined && search !== null && search !== '') {
            queryParameters = queryParameters.set('search', <string>search);
        }

        return this.http.get<CustomerReportExport>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(customerId))}/debtors/export`,
        {
            params: queryParameters
        });
    }
    
    checkDashboardAT(publicId: string): Observable<Configuration>{
        if (publicId === null || publicId === undefined) {
            throw new Error('Required parameter publicId was null or undefined when calling payment code configuration.');
        }
        return this.http.get<Configuration>(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/payout_dashboard.configuration`);
    }
}//end class
